import { List, Map } from 'immutable';
import api from '@synergycms_core/utils/api';
import { lowerFirst } from '../../utils';
import storage from '@synergycms_core/utils/storage';
import actions from '../actions';
import moment from 'moment';

/**
 * Método para discernir si el usuario que recibimos es un usuario del corporate antiguo
 * o del nuevo corporate.
 * 
 * La idea es tirar siempre por el company_id y pasarlo en la url como tal
 * el problema está en que el corporate antiguo no tiene company_id, sino que tiene 
 * el campo 'afiliado' que es el que se usaba para identificar la empresa y se corresponde
 * con el company_code
 */
export const getCompanyAvailIdentifier = (corporateUser) => {
  if(corporateUser?.get('company_id', false)) {
    return {
      key: 'company_id',
      value: corporateUser?.get('company_id')
    }
  } else {
    return false;
  }
}

export const refreshCorporateReservation = ({dispatch, getState}) => {
  const store = getState();
  const user = store.getIn(['customer', 'corporate']) || null;
  const reservation  = store.getIn(['customer', 'reservation']);
  const customerActions = actions.customer;

  let corporateConfig = null;

  if(user) {
    
    const corporateObject = getCompanyAvailIdentifier(user);
    dispatch(customerActions.params.updateParams(Map({
      [corporateObject.key] : corporateObject.value
    })));

    if (reservation?.size ) {
      corporateConfig =  Map({
        channel: 'Corporate',
        [corporateObject.key]: corporateObject.value,
      });
    }

  }

  if(!user) {
    // Removemos rastros de identificadores en la disponibilidad
    dispatch(customerActions.params.updateParams(Map({
      avail_code : null, 
      company_id: null
    })));

    corporateConfig = Map({
      channel: 'Web',
      company_code: null,
      company_id: null
    });

  }
  
  const isNotFinallyConfirmed = reservation && reservation.get('status', false) !== 'confirmed';

  if(reservation && reservation.size && isNotFinallyConfirmed) {
    let value = Map({
      tracking_id: reservation.get('tracking_id'),
      channel: corporateConfig.get('channel'),
      company_code : corporateConfig.get('company_code'),
      company_id : corporateConfig.get('company_id'),
    });

    if (reservation.getIn(['promotion', 'code'], null)) { //promotion code
      value = value.set('promotion_code', reservation.getIn(['promotion', 'code']));
    }
    if (reservation.getIn(['gift_voucher', 'code'], null)) { // gift voucher
      value = value.set('gift_voucher', reservation.getIn(['gift_voucher', 'code']));
    }

    const availPromise = dispatch(actions.avail.getAvailAsync());

    return dispatch(actions.customer.reservation.postAsync(value, false)).then(() => {
      dispatch(actions.customer.params.updateParams(value.delete("tracking_id")));
      return availPromise.then(()=> dispatch(actions.avail.getAvailParsed())).then(()=>{
        return dispatch(actions.customer.reservationRequest.refreshBlocks(value)).then(() => {
          return dispatch(actions.router.update());
        });
      });
    });
  } else if(getState().getIn(["customer","params", "params"])){
    dispatch(actions.availCalendar.refresh());
    return dispatch(actions.avail.getAvailAsync()).then(()=>{
      dispatch(actions.avail.getAvailParsed())
      dispatch(actions.customer.reservationRequest.initialize());
    });
  } else {
    return Promise.resolve();
  }

}

export default {
  SET_PAYFORMS: corporatePayforms => {
    return corporatePayforms;
  },
  SET_PAYFORMS_ASYNC: (trackingId, pinCode) => {
    return (dispatch, getState) => {
      const store = getState();
      const corporateStore = store.getIn(['customer', 'corporate']) || Map();
      const companyCode = corporateStore.get('afiliado', false) || corporateStore.get('avail_code', false) || false;
      const hotelId = store.getIn(['customer', 'current_hotel']);

      const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingId + ':' + pinCode) }];
      if (companyCode) {
        return api.get(`cms/corporate_payforms/${companyCode}`, {}, hotelId, extraHeaders).then(response => {
          const corporatePayforms = (!(response.success === false)
            ? response.reduce((accumResponse, item) => {
                return accumResponse.push(Map(item).set('name', lowerFirst(item.name)));
              }, List())
            : List()
          ).sortBy(payForm => payForm.get('weight'));
          storage.setLocal('corporate_payforms', corporatePayforms.toJS());
          return corporatePayforms;
        });
      } else {
        return List();
      }
    };
  },
  GET: loginInfo => {
    return loginInfo;
  },
  GET_USER_ASYNC: (loginContext, userToken, remember, userData) => {
    return (dispatch, getState) => {
      return api.get({
        path: 'company/user',
        params: { q: `${loginContext.key}:${loginContext.value}`},
        headers: [{'Authorization': `Basic ${userToken}`}],
        store: ({store, request}) => {

          const { token } = userData;
          
          if(!store[token]){
            store[token] = request();
          }
          
          return store[token];
        }
      }).then(response => {

        const destroyEvent = new CustomEvent('destroySession');

        const { expiration_time } = userData;

        if(Object.hasOwn(response, 'success') || moment().isAfter(expiration_time)){
          document.dispatchEvent(destroyEvent);
          return Map();
        }
      
        let corporateUser = {};
        if(remember){
          corporateUser = {...storage.getLocal('login_user'), ...response}
          storage.setLocal('login_user', corporateUser);
        } else {
          corporateUser = {...storage.get('login_user'), ...response}
          storage.set('login_user', corporateUser);
        }

        /*const event = new CustomEvent('setSessionCompany', {detail: corporateUser});
        document.dispatchEvent(event);*/

        return corporateUser;

      }).catch(() => {
        const destroyEvent = new CustomEvent('destroySession');
        document.dispatchEvent(destroyEvent);
        return Map();
      });
    }
  },
  UPDATE: (corporate) => {
    return corporate;
  },
  LOGOUT: () => (dispatch, getState) => {
    storage.unsetLocal("login_user");
    storage.unset("login_user");
    dispatch(actions.customer.corporate.update(null));
    return refreshCorporateReservation({dispatch, getState});
  }
};
